import { ArrowRight, MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/content";
import { Reveal } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

export const CtaBand = () => (
    <section data-testid="cta-band" className="py-24 lg:py-28 relative overflow-hidden">
        <div
            className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0D131F]/60 to-transparent"
            aria-hidden="true"
        />
        <div
            className="absolute top-0 left-1/2 -translate-x-1/2 h-64 w-[42rem] rounded-full bg-[#F5C518]/8 blur-[110px]"
            aria-hidden="true"
        />
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto relative text-center">
            <Reveal>
                <p className="font-jbmono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-5">
                    Get Started
                </p>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
                    Have an Idea? <span className="text-gradient-gold">Let&rsquo;s Build It.</span>
                </h2>
                <p className="mt-5 text-sm sm:text-base text-slate-400 max-w-xl mx-auto leading-relaxed">
                    Tell us what your business needs. We&rsquo;ll help you turn the idea into a
                    practical digital solution.
                </p>
                <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                    <button
                        data-testid="cta-start-project"
                        onClick={() => scrollToId("#contact")}
                        className="group inline-flex items-center gap-2 rounded-full bg-[#F5C518] px-8 py-4 text-sm sm:text-base font-semibold text-[#07090E] transition-all duration-300 hover:bg-[#E5B50F] hover:shadow-[0_0_36px_-6px_rgba(245,197,24,0.55)] active:scale-95"
                    >
                        Start a Project
                        <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                    <a
                        data-testid="cta-whatsapp"
                        href={CONTACT.waDefault}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 px-7 py-4 text-sm sm:text-base font-medium text-emerald-300 transition-all duration-300 hover:bg-emerald-400/10 active:scale-95"
                    >
                        <MessageCircle size={17} />
                        Chat on WhatsApp
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
